/* eslint-disable import/prefer-default-export */

import { Path, LocationDescriptor, LocationState as HistoryLocationState, History } from 'history';

export function historyPush(
  history: History,
  location: Path | LocationDescriptor<HistoryLocationState>,
  state?: HistoryLocationState
) {
  const previousPath = history.location.pathname;
  const newState = state ? { ...(state as Record<string, unknown>), previousPath } : { previousPath };

  history.push(location, newState);
}
